import { ReactNode } from "react";
import { useTheme } from "@mui/material/styles";

/** CSS custom property name for the project accent color */
export const PROJECT_ACCENT_VAR = "--project-accent";

interface ProjectThemeProviderProps {
  project: {
    colors?: { button_gradient_start: string } | null;
  };
  children: ReactNode;
}

export default function ProjectThemeProvider({
  project,
  children,
}: ProjectThemeProviderProps) {
  const theme = useTheme();
  const accent =
    project.colors?.button_gradient_start || theme.palette.primary.main;

  return (
    <div style={{ [PROJECT_ACCENT_VAR]: accent, display: "contents" } as React.CSSProperties}>
      {children}
    </div>
  );
}
